import './App.css';
import { createBrowserRouter, RouterProvider, } from "react-router-dom";
import Embed from "./pages/Embed/Embed.lazy";
import Preview from "./pages/Preview/Preview.lazy";
import Share from "./pages/Share/Share.lazy";
import Password from "./pages/Password/Password.lazy";
import Error from "pages/Error/Error.lazy";
import { IdAndStateProvider } from "providers/IdAndState.provider";
import { PlayerConfigProvider } from "providers/PlayerConfig.provider";

function App() {

  const router = createBrowserRouter(
    [
      {
        path: "/",
        element: <Error isDefault={true}/>,
      },
      {
        path: "/share/:id",
        element: (
            <IdAndStateProvider>
              <PlayerConfigProvider>
                <Share/>
              </PlayerConfigProvider>
            </IdAndStateProvider>
        ),
      },
      {
        path: "/embed/:id",
        element: (
            <IdAndStateProvider>
              <PlayerConfigProvider>
                <Embed/>
              </PlayerConfigProvider>
            </IdAndStateProvider>
        ),
      },
      {
        path: "/password",
        element: <Password/>,
      },
      {
        path: "/media/:id",
        element: <Preview/>,
      },
      {
        path: "/error",
        element: <Error/>,
      },

    ]
  );

  return <RouterProvider router={router} fallbackElement={<p>Loading...</p>}/>;
}

export default App;
